export default __webpack_public_path__ + "static/media/167.c31b7bb0.png";